<template >
    <div class="footer-social">
        <ul class="p-0 m-0 w-100" >
            <li class="facebook">
                <a href="https://www.facebook.com/Mr-Khaled-Sakr-103575551472868" target="_blank">
                    <img src="@/assets/social media/facebook.png" alt="">
                </a>
            </li>
            <li class="whatsapp">
                <a href="https://api.whatsapp.com/send?phone=201093092870">
                    <img src="@/assets/social media/whatsapp.png" alt="">
                </a>
            </li>
            <li class="tik">
                <a href="">
                    <img src="@/assets/social media/tiktok.png" alt="">
                </a>
            </li>
            <li class="insta">
                <a href="https://www.instagram.com/mrkhaledsakr" target="_blank">
                    <img src="@/assets/social media/instagram.png" alt="">
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'SocialMediaComponent' ,
    components: {
    }
}
</script>
<style scoped >
    .footer-social {
        padding: 1.5rem 0;
        border-bottom: 1px solid #81BFDA;
    }
    ul {
        list-style: none;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    ul li {
        width: 50px;
        height: 50px;
        /* border-radius: 50%; */
        overflow: hidden;
        margin-left: 0.8rem;
    }
    ul li a {
        all: unset;
        /* padding: 0.5rem; */
        display: block;
        cursor: pointer;
        width: 100%;
        height: 100%;
        font-size: 2rem;
    }
    ul li a img {
        width: 100%;
        height: 100%;
    }
</style>